module.exports = __webpack_public_path__ + "static/media/himalayan-beauty.02fdb53d.png";